import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';

export const AdminSectionTitle = ({ title, tooltip }: { tooltip: string; title: string }) => {
  return (
    <div className='h5 d-flex align-items-center gap-2'>
      {title}
      <SimpleTooltip className='float-right' text={tooltip}>
        <i
          className='fal text-lg fa-info-circle text-ThemeIconSecondary'
          data-testid='section-title-info-icon'
        />
      </SimpleTooltip>
    </div>
  );
};
